import React from 'react'
import Tooltip from 'LuxKit/Tooltip'
import TextLink from 'LuxKit/TextLink'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import usePersonalPortalHref from 'hooks/usePersonalPortalHref'
import useSocieteCampaignTargetTier from 'loyalty/hooks/useSocieteCampaignTargetTier'

/**
 * Hoverable info-circle tooltip used inside Société Campaign disclaimers
 * (e.g. on the gold member card) to explain Société Gold eligibility.
 */
function SocieteCampaignDisclaimerTooltip() {
  const personalPortalHref = usePersonalPortalHref()
  const societeHref = `${personalPortalHref}/societe`
  const { targetTier, targetTierDisplayName } = useSocieteCampaignTargetTier()

  return <Tooltip
    description={<>
      To be eligible for {targetTierDisplayName} status, you must first be a Société member. Log in to your linked
      {' '}<TextLink href={societeHref} target="_blank">Luxury Escapes</TextLink>{' '}
      account and navigate to the
      {' '}<TextLink href={societeHref} target="_blank">Société</TextLink>{' '}
      page where you can join for free.
    </>}
  >
    <LineInfoCircleIcon size={16} colour={`tier-${targetTier}-contrast`} style={{ display: 'block', opacity: 0.7 }} />
  </Tooltip>
}

export default SocieteCampaignDisclaimerTooltip
